var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgExlyWhite = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 25,
    viewBox: "0 0 49 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.592 4.44V7.848H10.088V11.016H4.592V14.712H10.808V18H0.488V1.152H10.808V4.44H4.592ZM21.3924 18L18.8244 14.28L16.6644 18H12.2244L16.6404 11.16L12.1044 4.608H16.7124L19.2804 8.304L21.4404 4.608H25.8804L21.3924 11.352L26.0004 18H21.3924ZM31.6858 0.24V18H27.5818V0.24H31.6858ZM48.3399 4.608L39.9399 24.36H35.5239L38.5959 17.544L33.1479 4.608H37.7319L40.8279 12.984L43.8999 4.608H48.3399Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExlyWhite, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ExlyWhite.fde50a07.svg";
export { ForwardRef as ReactComponent };